<template>
    <div>
        <van-row>
            <van-col span="12" style="border-right: 1px solid #e3e3e3" @click="showPopupL">分组浏览</van-col>
            <van-col span="12" @click="showPopupR">排序</van-col>
        </van-row>
        <p v-show="url == 'chkd'">
            温馨提示：目前仅能下载期刊文献，其他类型文献无法下载。
        </p>
        <div class="listCon">
            <p>
                共检索到<span>{{ totalNum }}</span
                >篇文章
            </p>
            <van-list v-model="loading" :finished="finished" :immediate-check="false" offset="10">
                <div v-for="(item, index) in list" :key="index" class="con">
                    <h4>
                        <router-link
                            v-html="index + 1 + ' . ' + item.ti"
                            :to="{ path: '/' + routerUrl, query: { url: decodeURIComponent(item.url) } }"
                            class="homePan"
                        >
                        </router-link>
                    </h4>
                    <div>
                        <p>
                            发表时间:<span>{{ item.postdate }}</span>
                        </p>
                        <p>
                            作者:<span>{{ item.au }}</span>
                        </p>
                        <p>
                            来源:<span>{{ item.so }}</span>
                        </p>
                        <p style="display:inline-block;width:50%">
                            下载次数:<span>{{ item.downloadNum }}</span>
                        </p>
                        <p style="display:inline-block;width:50%">
                            被引次数:<span>{{ item.citedNum }}</span>
                        </p>
                    </div>
                </div>
                <div v-show="listShow">
                    暂无数据
                </div>
            </van-list>
            <p v-if="error" class="err">请求失败，点击重新加载 <van-button @click="retry()">重新加载</van-button></p>
        </div>
        <van-popup v-model="showL" position="left" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="分组浏览" />
            <van-collapse v-model="activeName" accordion @change="facet($event)">
                <van-collapse-item v-for="(item, index) in collapseItem" :key="index" :title="item.title" :name="item.name">
                    <p style="text-align:center;padding: 10px 0;" v-show="shoeP">
                        暂无数据
                    </p>
                    <van-loading size="24px" v-show="shoeLo">加载中...</van-loading>
                    <van-cell v-for="(item1, index1) in activList" :key="index1" :class="{ active: index1 == currentLeft && index == LeftType }">
                        <template slot="title">
                            <span
                                class="custom-title"
                                style="width: 100%; display: block;"
                                @click="facetCick($event, index1, index, 'left', item1.url)"
                                >{{ item1.label }}<span style="float: right;">({{ item1.value }})</span></span
                            >
                        </template>
                    </van-cell>
                </van-collapse-item>
            </van-collapse>
            <van-button type="info" block @click="cancel()">清除筛选</van-button>
        </van-popup>
        <van-popup v-model="showR" position="right" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="排序" />
            <div class="right">
                <van-cell v-for="(item1, index1) in derUrl" :key="index1" :class="{ active: index1 == currentRight }">
                    <template slot="title">
                        <span class="custom-title" @click="facetCick($event, index1, '', 'right', item1.url)">{{ item1.title }}</span>
                        <van-icon
                            name="descending"
                            color="red"
                            :class="{ vanIcon: vanRight == 0 }"
                            style="display:none"
                            data-id="1"
                            :ref="'iconRef' + index1"
                            v-if="url == 'chkd'"
                        />
                    </template>
                </van-cell>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { Toast } from "vant";
// import qs from 'qs'
import api from "../request/api";
export default {
    props: ["collapseItem", "url"],
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            error: false,
            showL: false,
            showR: false,
            shoeP: false,
            shoeLo: false,
            isActive: false,
            listShow: false,
            data: {},
            totalNum: 0,
            activeName: 0,
            activList: [],
            Url: this.url,
            routerUrl: this.url + "Details",
            derUrl: [],
            pageUrl: "",
            page: 1,
            currentLeft: -1,
            LeftType: "",
            currentRight: "",
            vanRight: 1
        };
    },
    mounted() {
        this.data = this.$route.query;
        this.getSearch();

        let that = this;
        window.onscroll = function() {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                //写后台加载数据的函数
                that.onLoad();
            }
        };
    },
    methods: {
        retry() {
            this.getSearch();
        },
        getSearch() {
            this.listShow = false;
            //默认列表数据接口调用
            api.search(this.Url, this.data).then((response) => {
                if (response.code == 0) {
                    if (response.data.list == null) {
                        this.listShow = true;
                    } else {
                        this.totalNum = response.data.total;
                        if (this.data.page == 1) {
                            this.list = response.data.list;
                        } else {
                            this.list = this.list.concat(response.data.list);
                        }
                        this.pageUrl = response.data.pageUrl;
                    }
                    this.facetUrl(response.data);
                    this.showL = false;
                    this.showR = false;
                } else if (response.code == -99) {
                    this.error = true;
                }
            });
        },
        //右侧排序赋值url
        facetUrl(responseData) {
            this.derUrl = [];
            switch (this.Url) {
                case "chkd":
                    this.derUrl.push(
                        { title: "发表时间", url: responseData.pubtimeOrderUrl },
                        { title: "相关度", url: responseData.subjectOrderUrl },
                        { title: "被引", url: responseData.citedOrderUrl },
                        { title: "下载", url: responseData.downloadOrderUrl }
                    );
                    break;
                case "cnki":
                    // { title: "发表时间", url: responseData.pubtimeSortUrl },
                    // { title: "相关度", url: responseData.relevantSortUrl },
                    // { title: "被引", url: responseData.citedSortUrl },
                    // { title: "下载", url: responseData.downloadSortUrl }
                    this.derUrl.push(
                        { title: "相关度", url: "RELEVANT" },
                        { title: "发表时间", url: "PT" },
                        { title: "被引", url: "CITY" },
                        { title: "下载", url: "DOWNLOAD" },
                        { title: "综合", url: "ALL" }
                    );
                    break;
            }
        },
        //分面面板切换
        facet(event) {
            this.activList = "";
            if (event != "") {
                this.shoeLo = true;
                this.shoeP = false;
                api.facet(this.Url, { type: event }).then((response) => {
                    if (response.code == 0) {
                        this.activList = response.data.list;
                        this.shoeLo = false;
                        if (response.data.list.length == 0) {
                            this.shoeP = true;
                        } else {
                            this.shoeP = false;
                        }
                    }
                });
            }
        },
        //点击分面
        facetCick(e, index1, index, LR, dataUrl) {
            var url = decodeURIComponent(dataUrl);
            if (LR == "left") {
                this.currentLeft = index1;
                this.LeftType = index;
                this.currentRight = -1;
            } else {
                this.currentRight = index1;
                if (e != "") {
                    if (this.url == "chkd" && e.target.innerText == "相关度") {
                        this.vanRight = 1;
                    } else {
                        this.vanRight = 0;
                    }
                }
                var icon = this.$refs["iconRef" + index1];
                if (icon.dataset.id == 1) {
                    icon.setAttribute("data-id", "0");
                    icon.setAttribute("class", "van-icon van-icon-descending vanIcon");
                    icon.setAttribute("name", "ascending");
                } else {
                    icon.setAttribute("name", "descending");
                    icon.setAttribute("class", "van-icon van-icon-ascending vanIcon");
                    url = url.replace("+desc", "");
                    icon.setAttribute("data-id", "1");
                }
            }
            api.refine(this.Url, { url: url }).then((response) => {
                if (response.code == 0) {
                    if (response.data.list == null) {
                        this.listShow = true;
                    } else {
                        this.totalNum = response.data.total;
                        this.list = response.data.list;
                        this.activList = "";
                        this.activeName = -1;
                    }
                    this.facetUrl(response.data);
                    this.showL = false;
                    this.showR = false;
                } else {
                    Toast("检索失败");
                }
            });
        },
        //加载更多数据
        onLoad() {
            if (this.$route.name === this.url + "List") {
                this.listShow = false;
                if (this.totalNum == this.list.length) {
                    this.finished = true;
                } else {
                    setTimeout(() => {
                        this.page = Number(this.page) + 1;
                        var thisPage = decodeURIComponent(this.pageUrl);
                        thisPage = thisPage.replace(/{page}/g, this.page);
                        api.refine(this.Url, { url: decodeURIComponent(thisPage) }).then((response) => {
                            if (response.code == 0) {
                                if (response.data.list == null) {
                                    this.listShow = true;
                                } else {
                                    this.listShow = false;
                                    this.totalNum = response.data.total;
                                    this.list = this.list.concat(response.data.list);
                                }
                                this.loading = false;
                            }
                        });
                    }, 1000);
                }
            }
        },
        showPopupL() {
            this.showL = true;
        },
        showPopupR() {
            this.showR = true;
        },
        cancel() {
            this.page = 1;
            this.currentLeft = -1;
            this.LeftType = "";
            this.getSearch();
            this.showL = false;
        }
    }
};
</script>

<style lang="less">
.listCon {
    .err {
        text-align: center;
        font-size: 0.9rem;
        padding-top: 2rem !important;
        button {
            display: block;
            margin: 0.5rem auto;
            background: #1989fa;
            color: #fff;
        }
    }
}
.van-checkbox-group {
    > div {
        padding: 0.5rem 0;
        .van-checkbox__label {
            width: 100%;
        }
    }
}
.van-cell.active {
    span {
        display: inline-block !important;
        color: red;
    }
    .vanIcon {
        display: inline-block !important;
        font-size: 1rem;
        vertical-align: middle;
        margin-left: 5px;
    }
}
.van-popup {
    .van-collapse {
        height: 34rem;
        overflow: auto;
    }
    .van-button--block {
        position: fixed;
        bottom: 0;
    }
}
.van-popup > .van-cell {
    border-bottom: 1px solid #ebedf0;
    > .van-cell__title {
        > span {
            font-size: 1rem;
            font-weight: 700;
        }
    }
}
.right {
    .van-cell__title {
        width: 100%;
        text-align: center;
    }
}
</style>
